// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"08c105a4","56":"4e7c1567","311":"246df329","336":"d70ac43b","380":"ede5f32b","384":"2ebf21f9","392":"0ddf2d1b","417":"8ae78357","665":"ce43f9cf","895":"6d2b672b","912":"f860a791"}[chunkId] + ".chunk.js";
};